import {Col, Modal, Row, Table, message} from "antd";
import React, {useState} from "react";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {useStore} from "../../../../hooks/useStore";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import CourierTypeModal from "./CourierTypeModal";
import {ClickableSpan} from "../../../pools/poolIntensities/responsiveDataTable/ResponsiveDataTable.styles";
import MapPopup from "./MapPopup";
import CalculatedTableDetail from "./CalculatedTableDetail";
import WarningModal from "./warningModal/WarningModal";
import UnreceivedModal from "./unreceivedModal/UnreceivedModal";

const CalculatedTable = ({transferReferenceData, transferReferenceDataLoading}) => {
    const stores = useStore();
    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mileInformations, setMileInformations] = useState([]);
    const [selectedMapData, setSelectedMapData] = useState(null);
    const [isMapVisible, setIsMapVisible] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
    const [warningModalData, setWarningModalData] = useState(null);
    const [isUnreceivedModalOpen, setIsUnreceivedModalOpen] = useState(false);
    const [unreceivedModalData, setUnreceivedModalData] = useState(null);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const returnTransferEditHandler = async () => {
        try {
            setShowLoading(true);
            const transferReferenceId = new URLSearchParams(history.location.search).get("id");
            const response = await stores.transferStore.returnTranferReferenceEdit({
                transferReferenceId
            });
            if (response) {
                history.push(`/transfers/transfer-rotate?id=${transferReferenceId}&status=created`);
            }
        } catch (error) {
            console.error("Return transfer edit error:", error);
        } finally {
            setShowLoading(false);
        }
    };

    const createTransferWithReference = async () => {
        try {
            setShowLoading(true);
            const transferReferenceId = new URLSearchParams(history.location.search).get("id");
            const response = await stores.transferStore.createTransferWithReference({
                referenceId: transferReferenceId
            });

            if (response?.result?.summary?.totalUnreceived > 0) {
                setIsUnreceivedModalOpen(true);
                setUnreceivedModalData(response?.result);
            } else {
                setIsWarningModalOpen(true);
                setWarningModalData(response?.result);
            }
        } catch (error) {
            message.error("Transfer oluşturulurken bir hata oluştu");
        } finally {
            setShowLoading(false);
        }
    };

    const confirmModal = ({description}) => {
        Modal.confirm({
            title: "Onaylıyor musunuz?",
            icon: <ExclamationCircleOutlined />,
            content: description,
            okText: "Evet",
            onOk: createTransferWithReference,
            cancelText: "Hayır"
        });
    };

    return (
        <>
            <Row justify="end" style={{marginBottom: "20px"}}>
                <Col>
                    <CustomButton onClick={returnTransferEditHandler}>
                        Düzenlemeye Geri Dön
                    </CustomButton>
                </Col>
                <Col>
                    <CustomButton
                        type="primary"
                        onClick={() =>
                            confirmModal({
                                description: "Transferleri oluşturmak istediğinize emin misiniz?"
                            })
                        }
                    >
                        Transferleri Oluştur
                    </CustomButton>
                </Col>
            </Row>
            <CalculatedTableDetail
                transferReferenceData={transferReferenceData}
                mileInformations={mileInformations}
                setMileInformations={setMileInformations}
                showModal={showModal}
                setSelectedMapData={setSelectedMapData}
                loading={showLoading || transferReferenceDataLoading}
            />
            <CourierTypeModal
                mileInformations={mileInformations}
                modalState={[isModalOpen, setIsModalOpen]}
            />
            {selectedMapData && (
                <MapPopup
                    encodedPolylines={selectedMapData}
                    onClose={() => setSelectedMapData(null)}
                />
            )}
            <WarningModal
                isWarningModalOpen={isWarningModalOpen}
                setIsWarningModalOpen={setIsWarningModalOpen}
                warningModalData={warningModalData}
            />
            <UnreceivedModal
                isUnreceivedModalOpen={isUnreceivedModalOpen}
                setIsUnreceivedModalOpen={setIsUnreceivedModalOpen}
                unreceivedModalData={unreceivedModalData}
            />
        </>
    );
};

export default CalculatedTable;
